import { API } from '@ax/api';
import { API_SERVICES } from './utils';
import {
  ProviderLoginResponse,
  ProviderLoginInput,
  ProviderPasscodeLoginInput,
} from './auth-interface';
import { DEVICE_TAG, DEVICE_VERSION_CODE, DEVICE_VERSION_NAME } from './common-constants.ts';

export const providerLoginApi = async ({
  email,
  password,
}: ProviderLoginInput): Promise<ProviderLoginResponse> => {
  const res = await API.post(API_SERVICES.AUTH_API, `/token`, {
    params: {
      grantType: 'password',
      idp: 'com.augmedix.legacy',
    },
    data: {
      username: email,
      password,
      userType: 'provider',
    },
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};

export const providerPasscodeLoginApi = async ({
  username,
  passcode,
}: ProviderPasscodeLoginInput): Promise<ProviderLoginResponse> => {
  const res = await API.post(API_SERVICES.AUTH_API, `/token`, {
    params: {
      grantType: 'password',
      idp: 'com.augmedix.legacy',
    },
    data: {
      username,
      passcode,
      authType: 'passcode',
      userType: 'docApp',
      deviceTag: DEVICE_TAG,
      versionCode: Number(DEVICE_VERSION_CODE),
      versionName: DEVICE_VERSION_NAME,
      debugCheckEnabled: false,
      appCheckEnabled: false,
      rootCheckEnabled: false,
    },
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  return res.data;
};
